import z from 'zod';

export const DocumentExtractionImportFileSchema = z.object({
  contentType: z.string().nullish(),
  fileUri: z.string().nullish(),
  fileId: z.string().nullish(),
  fileName: z.string().nullish(),
  storageServiceFileId: z.string().nullish(),
  sourceFormat: z.literal('NISSAN_DIGLAS').optional(),
  zipIds: z.array(z.string()).nullish(),
  status: z.enum(['pending', 'success', 'error']).nullish(),
  errorMessage: z.string().nullish(),
});

export type DocumentExtractionImportFile = z.infer<typeof DocumentExtractionImportFileSchema>;
